import React, { useContext, useEffect, useState } from "react";
import { 
    getRedirectResult,
    isSignInWithEmailLink,
    signInWithRedirect,
    sendSignInLinkToEmail,
    signInWithEmailLink,
    signOut
} from 'firebase/auth';
import { auth, provider } from "../firebase";
import { ToastContext } from "./ToastContext";

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
    const { toast } = useContext(ToastContext);
    const [ user, setUser ] = useState(null);
    const [ isLoggedIn, setIsLoggedIn ] = useState(false);

    const loginWithEmail = (email) => {
        sendSignInLinkToEmail(auth, email, {
            url: `${window.location.origin}`,
            handleCodeInApp: true
        })
        .then(() => {
            toast(`Sign-In link sent to ${email}`);
            window.localStorage.setItem('emailForSignIn', email);
        });
    };

    const loginWithGoogle = () => {
        signInWithRedirect(auth, provider)
        .then(r => {
            console.log(r);
        })
        .catch(e => {
            console.log(e);
        });
    };

    const logout = () => {
        signOut(auth).then(() => {
            setUser(null);
        });
    };

    useEffect(() => {
        if (isSignInWithEmailLink(auth, window.location.href)) {
            let email = window.localStorage.getItem('emailForSignIn');
            if (!email) {
                email = window.prompt('Please provide your email for confirmation');
            }

            signInWithEmailLink(auth, email, window.location.href)
            .then((result) => {
                window.localStorage.removeItem('emailForSignIn');
                if (result?.user != null) {
                    setUser(result.user.toJSON());
                }
              })
        } else {
            getRedirectResult(auth).then(result => {
                if (result?.user != null) {
                    setUser(result.user.toJSON());
                } else if (auth.currentUser != null) {
                    setUser(auth.currentUser);
                }
            })
            .catch(e => {
                console.log(e);
            });
        }
    }, [])

    useEffect(() => {
        setIsLoggedIn(user !== null);
    }, [user]);

    return (
        <AuthContext.Provider value={{
            user,
            loginWithEmail,
            loginWithGoogle,
            logout,
            isLoggedIn,
        }}>
            { children }
        </AuthContext.Provider>
    );
}